import type { User } from '@aiassist/shared-types';
import { useQuery } from '@tanstack/react-query';
import type { ApiClient } from './client';

export const queryKeys = {
  me: ['me'] as const,
  config: ['config'] as const,
};

export function useMe(client: ApiClient) {
  return useQuery({
    queryKey: queryKeys.me,
    queryFn: () => client.get<User>('/v1/me'),
    staleTime: 60_000,
  });
}

export interface ServerConfig {
  models: Record<string, string>;
  feature_flags: Record<string, boolean>;
  prompt_template_versions: Record<string, string>;
}

export function useServerConfig(client: ApiClient) {
  return useQuery({
    queryKey: queryKeys.config,
    queryFn: () => client.get<ServerConfig>('/v1/config'),
    staleTime: 15 * 60_000,
  });
}
